<template>
    <div class="hotTitle">
        <div class="hotLine"></div>
        <span class="title">{{title}}</span>
    </div>
</template>

<script>
export default {
    props:["title"]

}
</script>

<style scoped>
 .hotTitle{
    margin-left: 12px;
    height: 16px;
    display: flex;
    align-items: center;
    /* margin-top: 25px;
    margin-bottom: 8px; */
    margin: 12px 12px;
  }
  .title{
      font-size: 15px;
      color: #333;
      font-weight: bold;
  }
  .hotLine{
    display: inline-block;
    width: 5px;
    height: 100%;
    border-radius: 3px;
    margin-right: 4px;
    background: -webkit-linear-gradient(rgba(255,255,255,1),#E3322B); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(rgba(255,255,255,1),#E3322B); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(rgba(255,255,255,1),#E3322B); /* Firefox 3.6 - 15 */
    background: linear-gradient(rgba(255,255,255,1),#E3322B); /* 标准的语法 */
  }
</style>


// WEBPACK FOOTER //
// src/components/lineTitle.vue